<template>
  <div id="layout-footer">
    <div class="footer-main">
      <div class="footer-item">
        <div class="footer-item-title">相关链接</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.github">
            <i class="iconfont icon-github"></i> GitHub
          </a>
        </div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.authConfig.gitee">
            <i class="iconfont icon-gitee"></i> Gitee
          </a>
        </div>
      </div>
      <div class="footer-item footer-center">
        <div class="footer-logo">{{ this.$store.state.webConfig.name }}</div>
        <div class="footer-slogan">一个热爱技术的博主</div>
      </div>
      <div class="footer-item">
        <div><i class="iconfont icon-shijian"></i> 已运行 <em class="run-time">{{ this.$store.state.runTimeInterval }}</em></div>
        <div><i class="el-icon-user"></i> 在线 <em class="online-count">{{ this.$store.state.onlinePerson }}</em> 人</div>
        <div>
          <a target="_blank" class="out-link" :href="this.$store.state.webConfig.managementUrl">☞ 后台管理</a>
        </div>
      </div>
    </div>
    <div class="footer-divider"></div>
    <div class="copyright">
      Copyright &copy; {{ this.$store.state.runTimeYear }}
      <a target="_blank" class="out-link" :href="this.$store.state.webConfig.webUrl">qiangesoft.cn</a>
      All Rights Reserved &nbsp;|
      <a target="_blank" class="out-link" href="https://beian.miit.gov.cn/">{{ this.$store.state.webConfig.recordNum }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout-footer",
  data() {
    return {

    }
  },
  computed: {
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="less">
#layout-footer {
  padding: 40px 0 0;
  color: rgba(255, 255, 255, 0.85);
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  font-size: 13px;
}

a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s;
}

.out-link:hover {
  color: #7b95fa;
}

.footer-main {
  max-width: 900px;
  margin: 0 auto 32px auto;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 0 20px;
}

.footer-item-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 14px;
  letter-spacing: 0.5px;
}

.footer-item div {
  margin-top: 10px;
  line-height: 1.8;
}

.footer-center {
  text-align: center;
}

.footer-logo {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #7b95fa 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.footer-slogan {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 1px;
}

.run-time {
  font-style: normal;
  background: linear-gradient(135deg, #667eea, #764ba2);
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
}

.online-count {
  font-style: normal;
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  padding: 1px 10px;
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 0 40px;
}

.copyright {
  text-align: center;
  padding: 16px 20px;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
  line-height: 2;
}

.copyright a {
  color: rgba(255, 255, 255, 0.5);
  margin: 0 4px;
}

.copyright a:hover {
  color: #7b95fa;
}
</style>
